export default __webpack_public_path__ + "static/media/ConallsValley.f0dfd878.jpg";